// src/contexts/AuthContext.js
import React, {
  createContext,
  useState,
  useEffect,
  useRef,
  useCallback,
} from "react";
// 💡 ASUMSI: Anda menggunakan react-hot-toast
import toast from "react-hot-toast";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const timeoutRef = useRef(null);

  const getStorageValue = (key) =>
    localStorage.getItem(key) || sessionStorage.getItem(key);

  // 💡 Tambahkan fungsi logout di sini untuk dipanggil oleh timer
  const logout = useCallback(() => {
    [
      "token",
      "NIP",
      "username",
      "namaLengkap",
      "idUser",
      "idRole",
      "idDepartemen",
      "isActive",
      "expired", // 💡 Pastikan 'expired' juga dibersihkan saat logout normal
    ].forEach((key) => {
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    });
    setIsAuthenticated(false);
    setUser(null);
    // Tidak perlu toast di sini, karena toast akan dipicu oleh pengecekan 'expired'
  }, []);

  // 🛑 FUNGSI BARU: Mengecek dan membersihkan flag expired
  const checkAndClearExpiredFlag = useCallback(() => {
    const isExpired = localStorage.getItem("expired") === "1";
    if (isExpired) {
      // 🛑 PESAN INI MUNCUL TANPA PANGGILAN NETWORK (saat mounting)
      toast.error("Sesi login Anda telah berakhir. Silakan login kembali.");
      localStorage.removeItem("expired");
    }
  }, []);

  const initUserFromStorage = useCallback(() => {
    const token = getStorageValue("token");
    const NIP = getStorageValue("NIP");
    const username = getStorageValue("username");
    const namaLengkap = getStorageValue("namaLengkap");
    // Convert string values to numbers
    const idUser = Number(getStorageValue("idUser"));
    const idRole = Number(getStorageValue("idRole"));
    const idDepartemen = Number(getStorageValue("idDepartemen"));
    const isActive = getStorageValue("isActive");

    // Periksa apakah ada token yang valid DAN data dasar
    if (token && NIP && idUser > 0) {
      setIsAuthenticated(true);
      setUser({
        NIP,
        username,
        namaLengkap,
        idUser, // Now a number
        idRole, // Now a number
        idDepartemen, // Now a number
        isActive,
      });
    } else {
      // Jika tidak ada token, panggil logout untuk memastikan storage bersih
      logout();
    }
    setLoading(false);

    // 💡 Jalankan pengecekan expired flag setelah inisialisasi user
    checkAndClearExpiredFlag();
  }, [logout, checkAndClearExpiredFlag]); // Tambahkan dependencies

  useEffect(() => {
    initUserFromStorage();
    // Hapus setLoading(false) dari sini karena sudah ada di initUserFromStorage
  }, [initUserFromStorage]);

  const login = (token, userData, remember = true) => {
    const storage = remember ? localStorage : sessionStorage;
    storage.setItem("token", token);
    storage.setItem("NIP", userData.NIP);
    storage.setItem("username", userData.username);
    storage.setItem("namaLengkap", userData.namaLengkap);
    // Ensure all values are stored as strings
    storage.setItem("idUser", String(userData.idUser));
    storage.setItem("idRole", String(userData.idRole));
    storage.setItem("idDepartemen", String(userData.idDepartemen));
    storage.setItem("isActive", String(userData.isActive));
    setIsAuthenticated(true);
    setUser(userData);

    // Pastikan flag expired dibersihkan saat login berhasil
    localStorage.removeItem("expired");
  };

  // 🛑 Hapus fungsi logout yang lama di sini karena sudah dipindahkan ke useCallback di atas.
  // const logout = () => { ... }

  useEffect(() => {
    const resetTimer = () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        logout(); // Memanggil fungsi logout
        localStorage.setItem("expired", "1");
        // 🛑 PERBAIKAN: Gunakan path konsisten dengan api.js
        window.location.href = "/PersediaanRsud/login";
      }, 60 * 60 * 1000); // 60 menit
    };

    if (isAuthenticated) {
      ["mousemove", "keydown", "scroll", "click"].forEach((event) =>
        window.addEventListener(event, resetTimer)
      );
      resetTimer();
    }

    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      ["mousemove", "keydown", "scroll", "click"].forEach((event) =>
        window.removeEventListener(event, resetTimer)
      );
    };
  }, [isAuthenticated, logout]); // 💡 Tambahkan 'logout' ke dependency array

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        user,
        login,
        logout,
        loading,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

// // src/contexts/AuthContext.js
// import React, {
//   createContext,
//   useState,
//   useEffect,
//   useRef,
//   useCallback,
// } from "react";

// export const AuthContext = createContext();

// export const AuthProvider = ({ children }) => {
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [user, setUser] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const timeoutRef = useRef(null);

//   const getStorageValue = (key) =>
//     localStorage.getItem(key) || sessionStorage.getItem(key);

//   const initUserFromStorage = useCallback(() => {
//     const token = getStorageValue("token");
//     const NIP = getStorageValue("NIP");
//     const username = getStorageValue("username");
//     const namaLengkap = getStorageValue("namaLengkap");
//     // Convert string values to numbers
//     const idUser = Number(getStorageValue("idUser"));
//     const idRole = Number(getStorageValue("idRole"));
//     const idDepartemen = Number(getStorageValue("idDepartemen"));
//     const isActive = getStorageValue("isActive");

//     if (token && NIP) {
//       setIsAuthenticated(true);
//       setUser({
//         NIP,
//         username,
//         namaLengkap,
//         idUser, // Now a number
//         idRole, // Now a number
//         idDepartemen, // Now a number
//         isActive,
//       });
//     }
//   }, []);

//   useEffect(() => {
//     initUserFromStorage();
//     setLoading(false);
//   }, [initUserFromStorage]);

//   const login = (token, userData, remember = true) => {
//     const storage = remember ? localStorage : sessionStorage;
//     storage.setItem("token", token);
//     storage.setItem("NIP", userData.NIP);
//     storage.setItem("username", userData.username);
//     storage.setItem("namaLengkap", userData.namaLengkap);
//     // Ensure all values are stored as strings
//     storage.setItem("idUser", String(userData.idUser));
//     storage.setItem("idRole", String(userData.idRole));
//     storage.setItem("idDepartemen", String(userData.idDepartemen));
//     storage.setItem("isActive", String(userData.isActive));
//     setIsAuthenticated(true);
//     setUser(userData);
//   };

//   const logout = () => {
//     [
//       "token",
//       "NIP",
//       "username",
//       "namaLengkap",
//       "idUser",
//       "idRole",
//       "idDepartemen",
//       "isActive",
//     ].forEach((key) => {
//       localStorage.removeItem(key);
//       sessionStorage.removeItem(key);
//     });
//     setIsAuthenticated(false);
//     setUser(null);
//   };

//   useEffect(() => {
//     const resetTimer = () => {
//       if (timeoutRef.current) clearTimeout(timeoutRef.current);
//       timeoutRef.current = setTimeout(() => {
//         logout();
//         localStorage.setItem("expired", "1");
//         window.location.href = "/login";
//       }, 60 * 60 * 1000); // 60 menit
//     };

//     if (isAuthenticated) {
//       ["mousemove", "keydown", "scroll", "click"].forEach((event) =>
//         window.addEventListener(event, resetTimer)
//       );
//       resetTimer();
//     }

//     return () => {
//       if (timeoutRef.current) clearTimeout(timeoutRef.current);
//       ["mousemove", "keydown", "scroll", "click"].forEach((event) =>
//         window.removeEventListener(event, resetTimer)
//       );
//     };
//   }, [isAuthenticated]);

//   return (
//     <AuthContext.Provider
//       value={{
//         isAuthenticated,
//         user,
//         login,
//         logout,
//         loading,
//       }}
//     >
//       {children}
//     </AuthContext.Provider>
//   );
// };
